import { render, staticRenderFns } from "./ScalesListComponent.vue?vue&type=template&id=ede59562&scoped=true&"
import script from "./ScalesListComponent.vue?vue&type=script&lang=js&"
export * from "./ScalesListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede59562",
  null
  
)

export default component.exports